import { Component, OnInit, Input, inject } from '@angular/core';
import { ClientStats } from 'app/core/models/client-stats.model';
import { Client } from 'app/core/models/client.model';
import { ClientsService } from 'app/core/services/clients.service';
import { DecimalPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-client-stats',
    templateUrl: './client-stats.component.html',
    styleUrls: ['./client-stats.component.scss'],
    imports: [MatProgressSpinner, DecimalPipe]
})
export class ClientStatsComponent implements OnInit {
  private clientsService = inject(ClientsService);

  @Input() client: Client;
  clientStats: ClientStats;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    this.loading = true;
    this.clientsService.getStats(this.client.id).subscribe(stats => {
      this.clientStats = stats;
      this.loading = false;
    });
  }
}
